import {
  TenantIconImage,
  TenantIconPlaceholder,
  TenantIconSvg,
} from "./components";

interface Props {
  svg?: string;
  image?: string;
  name?: string;
}

const TenantIcon = ({ svg, image, name }: Props) => {
  if (image) return <TenantIconImage image={image} />;

  if (svg) return <TenantIconSvg svg={svg} />;

  return <TenantIconPlaceholder name={name} />;
};

export default TenantIcon;
